module.exports = __webpack_public_path__ + "img/signature.f0b673b.webp";